// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__11sPt","text":"SelectPayment_text__3pF_Y","title":"SelectPayment_title__LGnGB","btn":"SelectPayment_btn__dh8dG"};